module.exports = __webpack_public_path__ + "img/dumpattenuator_stopped.5b6b98e5.svg";